import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import e from "react";
import t from "styled-components";
import { system as r, variant as o, compose as n, space as a, color as i, layout as l, flexbox as s, grid as c, background as p, border as f, position as d, shadow as u, typography as y, textStyle as m } from "styled-system";
import { interceptScales as b, composeScales as h, spaceScales as g, gridScales as O, positionScales as P, typographyScales as j } from "styled-system-scale";
import { isInternal as w } from "@walltowall/helpers";

function x(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function v() {
  return (v = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function N(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function S(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? N(Object(r), !0).forEach(function (t) {
      x(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return e;
}

function E(e, t) {
  if (null == e) return {};

  var r,
      o,
      n = function (e, t) {
    if (null == e) return {};
    var r,
        o,
        n = {},
        a = Object.keys(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
  }

  return n;
}

function F(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

var D = r({
  placeContent: !0,
  placeItems: !0,
  placeSelf: !0
}),
    k = r({
  transition: !0,
  transitionDuration: {
    property: "transitionDuration",
    scale: "transitionDurations"
  },
  transitionProperty: !0,
  transitionTimingFunction: !0
}),
    B = r({
  transform: !0,
  transformOrigin: !0
}),
    R = r({
  cursor: !0
}),
    I = r({
  outline: !0
}),
    A = r({
  visibility: !0
}),
    G = o({
  prop: "boxStyle",
  scale: "boxStyles"
}),
    T = b(h(g, O, P)),
    z = t.div(T(n(a, i, l, s, c, p, f, d, u, G, D, B, k, R, I, A)));
z.displayName = "Box", z.defaultProps = {
  display: "block",
  transitionDuration: "normal",
  transitionProperty: "none",
  transitionTimingFunction: "ease-out"
};

var H = function H(e, t) {
  for (t >= e.length && (t = e.length - 1); t > -1 && (null === e[t] || void 0 === e[t]);) {
    t--;
  }

  return e[t];
},
    W = function W(e) {
  return Array.isArray(e) ? e : [e];
},
    L = function L(e, t, r) {
  var o = [],
      n = Math.max(t.length, r.length);

  for (var _a = 0; _a < n; _a++) {
    o[_a] = e(H(t, _a), H(r, _a));
  }

  return o;
},
    V = e.forwardRef(function (t, r) {
  var o = t.x,
      n = t.y,
      a = t.children,
      i = E(t, ["x", "y", "children"]);
  return e.createElement(z, v({
    ref: r,
    position: "relative"
  }, i), e.createElement(z, {
    pt: L(function (e, t) {
      return "".concat(t / e * 100, "%");
    }, W(o), W(n)),
    "aria-hidden": !0
  }), e.createElement(z, {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }, a));
});

V.displayName = "AspectRatio";
var q = e.forwardRef(function (t, r) {
  var _t$maxWidth = t.maxWidth,
      o = _t$maxWidth === void 0 ? "xlarge" : _t$maxWidth,
      n = t.children,
      a = t.innerProps,
      i = E(t, ["maxWidth", "children", "innerProps"]);
  return e.createElement(z, v({
    ref: r
  }, i), e.createElement(z, v({
    maxWidth: o,
    mx: "auto",
    height: "100%"
  }, a), n));
});
q.displayName = "BoundedBox";
var C = b(j),
    M = t(z)(C(n(y, m)));
M.displayName = "Text";

var _ = t(M)({
  appearance: "none",
  "&:required": {
    boxShadow: "none"
  }
});

_.defaultProps = S({}, M.defaultProps, {
  as: "input",
  bg: "transparent",
  borderRadius: 0,
  color: "inherit",
  display: "block",
  lineHeight: 1,
  type: "text"
}), _.displayName = "Input";
var J = t(_)({});
J.defaultProps = S({}, _.defaultProps, {
  as: "button",
  cursor: "pointer",
  display: "inline-block",
  textAlign: "left"
}), J.displayName = "Button";
var K = t(z)({});
K.displayName = "Flex", K.defaultProps = S({}, z.defaultProps, {
  display: "flex"
});
var Q = b(O),
    U = t(z)(Q(function () {
  return {};
}));
U.displayName = "Grid", U.defaultProps = S({}, z.defaultProps, {
  display: "grid"
});
var X = t(M)({});
X.displayName = "Heading", X.defaultProps = S({}, M.defaultProps, {
  as: "h2"
});
var Y = r({
  objectFit: !0,
  objectPosition: !0
}),
    Z = t(z)(Y);
Z.displayName = "ImageBase", Z.defaultProps = {
  display: "block"
};
var $ = e.forwardRef(function (t, r) {
  var _t$objectFit = t.objectFit,
      o = _t$objectFit === void 0 ? "cover" : _t$objectFit,
      _t$objectPosition = t.objectPosition,
      n = _t$objectPosition === void 0 ? "50% 50%" : _t$objectPosition,
      a = t.imgStyle,
      i = E(t, ["objectFit", "objectPosition", "imgStyle"]);
  return e.createElement(Z, v({
    as: "img",
    ref: r,
    loading: "lazy",
    objectFit: o,
    objectPosition: n,
    height: "100%",
    width: "100%",
    style: S({
      fontFamily: '"object-fit: '.concat(o, "; object-position: ").concat(n, '"')
    }, a)
  }, i));
});
$.displayName = "Image";
var ee = e.forwardRef(function (t, r) {
  var o = t.href,
      n = E(t, ["href"]);
  return "string" == typeof o && o.match(/^https?:\/\/#/) && (o = o.replace(/^https?:\/\//, "")), e.createElement(M, v({
    as: "a",
    ref: r,
    href: o,
    rel: w(o) ? void 0 : "nofollow noopener noreferrer",
    cursor: "pointer",
    display: "inline"
  }, n));
});
ee.displayName = "Link";
var te = r({
  fill: {
    property: "fill",
    scale: "colors"
  }
}),
    re = t(z)(function (e) {
  return {
    "*": S({}, te(e))
  };
});
re.displayName = "SVGBase";
var oe = e.forwardRef(function (t, r) {
  var o = t.svg,
      n = t.fill,
      a = E(t, ["svg", "fill"]);
  return e.createElement(V, v({
    ref: r
  }, a), e.createElement(re, {
    as: o,
    fill: n,
    width: "100%",
    height: "100%"
  }));
});
oe.displayName = "SVG";
export { V as A, q as B, K as F, U as G, X as H, $ as I, ee as L, oe as S, M as T, E as _, z as a, J as b, _ as c, v as d, F as e };